class RotiHeader extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.setup()
    }
    setup() {
        gsap.set('body', { '--headerHeight': document.querySelector('.header-wrap').offsetHeight + 'px' })

        this.setHeightNav(document.querySelector('.nav-body-inner').offsetHeight)
        this.interact()
        this.interactMenuSticky()
        this.updateOnScroll(getLenis())
        getLenis().on('scroll', this.updateOnScroll);
        if (document.querySelectorAll('[data-hero="light"]').length >= 1) {
            this.classList.add('on-light-hero')
        }
    }
    interact() {
        const groupDropdowns = document.querySelectorAll('.nav-body-group');

        document.querySelector('.nav-btn-toggle').addEventListener('click', (e) => {
            e.preventDefault()
            this.setHeightNav(document.querySelector('.nav-body-inner').offsetHeight)

            if (document.querySelector('.nav-btn-toggle').classList.contains('active')) {
                document.querySelector('.nav-btn-toggle').classList.remove('active')
                document.querySelector('.nav-body').classList.remove('active')
            } else {
                document.querySelector('.nav-btn-toggle').classList.add('active')
                document.querySelector('.nav-body').classList.add('active')
                document.querySelector('.nav-body-inner').classList.remove('is-sub-nav')
                groupDropdowns.forEach(group => group.classList.remove('active'))
            }
        });
    }
    interactMenuSticky() {
        const dropdowns = document.querySelectorAll('.nav-body-item-dropdown');
        const groupDropdowns = document.querySelectorAll('.nav-body-group');
        const labelPathHome = document.querySelectorAll('.pathway-home');
        const listNavItems = document.querySelectorAll('.nav-body-item');

        dropdowns.forEach((dropdown, index) => {
            const dropdownList = groupDropdowns[index].querySelectorAll('.nav-body-group-item');
            dropdownList.forEach((item, idx) => {
                item.style.transitionDelay = `${idx * 0.075 + 0.1}s`
            })
            dropdown.addEventListener('click', () => {
                const dataGroup = dropdown.getAttribute('data-group-dropdown');
                const groupItem = document.querySelector(`.nav-wrap .nav-body-group.${dataGroup}`);
                if (groupItem) {
                    groupItem.classList.add('active');
                    document.querySelector('.nav-body-inner').classList.add('is-sub-nav')
                    this.setHeightNav(groupItem.clientHeight)
                }
            })
        })

        labelPathHome.forEach(label => label.addEventListener('click', () => {
            document.querySelector('.nav-body-inner').classList.remove('is-sub-nav');
            groupDropdowns.forEach(group => group.classList.remove('active'))
            this.setHeightNav(document.querySelector('.nav-body-inner').offsetHeight)
        }));
        listNavItems.forEach((nav, index) => {
            nav.style.transitionDelay = `${index * 0.075}s`
        })
    }
    convertPxToRem(px) {
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        return px / rootFontSize;
    }
    setHeightNav(heightContent) {
        gsap.set('.nav', { '--navHeight': `${this.convertPxToRem(heightContent)}rem` })
    }
    updateOnScroll = (inst) => {
        let isNavActive;

        if (window.innerWidth > 991) {
            isNavActive = inst.scroll >= this.offsetHeight && inst.scroll <= document.querySelector('.footer-wrap').offsetTop - window.innerHeight;
        } else {
            isNavActive = inst.scroll >= document.querySelector('.nav-head').offsetHeight * 1.5;
        }
        if (isNavActive) {
            document.querySelector('.nav-wrap').classList.add('active');
        } else {
            if (window.innerWidth > 991) {
                document.querySelector('.nav-btn-toggle').classList.remove('active')
                document.querySelector('.nav-body').classList.remove('active');
            }
            document.querySelector('.nav-wrap').classList.remove('active');
        }

        if (window.innerWidth < 767) {
            let isSideBarActive = inst.scroll <= document.querySelector('footer').offsetTop + document.querySelector('.footer-head').clientHeight - window.innerHeight;
            if (isSideBarActive) {
                if (inst.direction > 0) {
                    document.querySelector('.contact-wrap').classList.add('hide')
                } else {
                    document.querySelector('.contact-wrap').classList.remove('hide')
                }
            } else {
                document.querySelector('.contact-wrap').classList.add('hide')
            }
        }

    }
}
customElements.define('roti-header', RotiHeader)